/**
 * Maps CropConnect environment values to deploymentTarget values
 * for the FieldDataTaskManagementModule
 */

// eslint-disable-next-line import/no-unresolved
import { DeploymentTarget } from '@cropconnect/contracting-module/dist/frontend/shared/src/config/deploymentTargetsConfig';

/**
 * Maps the current application environment to the appropriate
 * FieldDataTaskManagementModule deploymentTarget value
 *
 * @returns The deployment target value for the FDTM module
 */
export const getDeploymentTarget = (): DeploymentTarget => {
  const environment = process.env.ENVIRONMENT;

  switch (environment) {
    case 'DEVELOPMENT':
      return 'development';
    case 'QUALITYTESTS':
      return 'qualityAssurance';
    case 'PRODUCTION':
      return 'production';
    default:
      console.warn(
        `Unknown environment: ${environment}, defaulting to development for FDTM module`
      );
      return 'development';
  }
};
